import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import ridesService from "@/rides/services/rides-service"
import RideCategory from '@/rides/models/ride-category'

@Component
export default class RideCategories extends Vue {
    private categoryHeaders = [
        { text: 'Name', value: 'title' },
        { text: '', value: 'action', sortable: false, align: 'right' },
    ]
    private categoriesLoading = false
    private categoryDialog = false
    private categories: RideCategory[] = []
    private editedCategoryIndex = -1
    private editedCategory: RideCategory = new RideCategory

    private snackbarText = 'Erfolgreich gespeichert.'
    private snackbarOpened = false

    private async mounted() {        
        this.fetchAllCategories()        
    }

    private create() {
        this.categoryDialog = true;
    }

    private get rideCategoryFormTitle(): string {
        return this.editedCategoryIndex === -1 ? 'Neue Kategorie' : 'Kategorie bearbeiten'
    }

    private async fetchAllCategories() {
        this.categoriesLoading = true
        const response = await ridesService.getRideCategoriesAsync()
        this.categories = response
        this.categoriesLoading = false
    }

    private editCategory(category: RideCategory) {
        this.editedCategoryIndex = this.categories.indexOf(category)
        this.editedCategory = Object.assign({}, category)
        this.categoryDialog = true
    }

    private async deleteCategory(category: RideCategory) {
        const index = this.categories.indexOf(category)
        if (confirm('Möchten Sie die Kategorie wirklich löschen?')) {
            await ridesService.removeCategoryAsync(category.id)
            this.fetchAllCategories()
        }
    }

    private closeEditCategory() {
        this.categoryDialog = false
        this.editedCategoryIndex = -1
        this.editedCategory = new RideCategory()
    }

    private async saveEditCategory() {
        if (this.editedCategoryIndex > -1) {
            await ridesService.updateCategoryAsync(this.editedCategory)
        } else {
            await ridesService.saveCategoryAsync(this.editedCategory)
        }
        this.fetchAllCategories()
        this.closeEditCategory()
    }
}